package org.vreo.devicehub.features.device.presentation.deviceList.components

import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlin.time.ExperimentalTime
import kotlin.time.Instant

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.LazyListState
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.ui.Alignment
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp

import org.vreo.devicehub.features.core.domain.device.device.AnprDevice
import org.vreo.devicehub.features.core.domain.device.device.ProductType

/**
 *  Device list composable, presents list of [AnprDevice] objects.
 *
 * @param devices list of devices to present
 * @param onDeviceClick click handler
 * @param modifier composable modifier
 * @param scrollState scroll state, defaults to [rememberLazyListState]
 * @param openItemClick on open item click handler, if set to null item will be disabled
 * @param unlinkItemClick on unlink item click, if set to null item will be disabled
 * @param deleteItemClick on delete item click, if set to null item will be disabled
 */
@Composable
fun DeviceList(
    devices: List<AnprDevice>,
    onDeviceClick: (AnprDevice) -> Unit,
    modifier: Modifier = Modifier,
    scrollState: LazyListState = rememberLazyListState(),
    openItemClick: ((device: AnprDevice) -> Unit)? = null,
    unlinkItemClick: ((device: AnprDevice) -> Unit)? = null,
    deleteItemClick: ((device: AnprDevice) -> Unit)? = null,

) {
    LazyColumn(
        state = scrollState,
        verticalArrangement = Arrangement.spacedBy(8.dp),
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = modifier
    ) {
        items(devices) { device ->
            DeviceItem(
                device = device,
                onClick = onDeviceClick,
                modifier = Modifier.fillParentMaxWidth(),
                openItemClick = openItemClick,
                unlinkItemClick = unlinkItemClick,
                deleteItemClick = deleteItemClick,
            )
        }
    }
}

@OptIn(ExperimentalTime::class)
@Preview
@Composable
fun DeviceListPreview() {
    val instant = Instant.fromEpochMilliseconds(1760360075238)
    val timeAndDate = instant.toLocalDateTime(TimeZone.currentSystemDefault())

    val deviceDemoList = listOf(
        AnprDevice(
            deviceId = "volt-s1-0001",
            device = ProductType.VoltS1PoleShortRange,
            serialNumber = "0001",
            softwareVersion = "1.2.3",
            ocrVersion = "1.2.3",
            localIpAddress = "192.168.1.1",
            macAddress = "111:222:333",
            active = true,
            lastActivityTime = timeAndDate,
        ),
        AnprDevice(
            deviceId = "volt-s1-0001",
            device = ProductType.VoltS1PoleShortRange,
            serialNumber = "0001",
            softwareVersion = "1.2.3",
            ocrVersion = "1.2.3",
            localIpAddress = "192.168.1.1",
            macAddress = "111:222:333",
            active = true,
            lastActivityTime = timeAndDate,
        )
    )

    DeviceList(
        devices = deviceDemoList,
        onDeviceClick = { }
    )
}